module.exports = __webpack_public_path__ + "static/media/02.53712b14.webp";